import * as React from "react"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import * as styles from "./style.module.scss"
import FloorMapSlider from "../FloorMapSlider/index"

import Heading from '../../images/akasaka/floorMap/heading.svg'

// data
type specItem = {
  heading: string,
  text: string
}
type sliderImages = {
  pc: string[],
  sp: string[],
}
type Content = {
  heading?: string,
  images: sliderImages,
  spec: {
    items: specItem[],
    image: string
  }
};

type Props = {
  isDesktop: boolean,
  contents: Content[],
  autoHeight: boolean
  minHeight?: number
}

// markup
const FloorMap = (props: Props) => {
  return (
    <div className={styles.floorMap}>
      <div className={styles.heading}>
        <img src={Heading} alt="Floor Map" />
        <span>フロアマップ</span>
      </div>
      <div className={styles.contents}>
        {props.contents.map(content => (
          <div key={content.heading} className={styles.content}>
            {content.heading && <div className={styles.contentHeading}>{ content.heading }</div>}
            <Tabs>
              <TabList className={styles.tabs}>
                <Tab className={styles.tab}>ギャラリー</Tab>
                <Tab className={styles.tab}>スペック</Tab>
              </TabList>
              <TabPanel>
                <div className={styles.sliderWrapper}>
                  <FloorMapSlider images={ props.isDesktop ? content.images.pc : content.images.sp } autoHeight={props.autoHeight} minHeight={props.minHeight} />
                </div>
              </TabPanel>
              <TabPanel>
                <div className={styles.spec}>
                  <div className={styles.specItems}>
                    {content.spec.items.map(item => (
                      <div className={styles.specItem}>
                        <div className={styles.specHeading}>{ item.heading }</div>
                        <div className={styles.specText}>{ item.text }</div>
                      </div>
                    ))}
                  </div>
                  <div className={styles.specImage}>
                    <img src={content.spec.image} alt="間取り図" />
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FloorMap
